var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4099 51.7581H47.5902V44.963H20.4099V51.7581ZM30.4327 41.5654L49.6288 22.3693L44.7873 17.6977L30.4327 32.0523L23.1279 24.7476L18.3714 29.5042L30.4327 41.5654ZM34.0001 68.7458C29.3001 68.7458 24.8833 67.8539 20.7497 66.0702C16.616 64.2865 13.0203 61.8657 9.96247 58.808C6.90468 55.7502 4.48393 52.1544 2.70022 48.0208C0.916513 43.8871 0.0246582 39.4703 0.0246582 34.7703C0.0246582 30.0704 0.916513 25.6536 2.70022 21.5199C4.48393 17.3863 6.90468 13.7905 9.96247 10.7327C13.0203 7.67494 16.616 5.2542 20.7497 3.47049C24.8833 1.68678 29.3001 0.794922 34.0001 0.794922C38.7 0.794922 43.1168 1.68678 47.2505 3.47049C51.3842 5.2542 54.9799 7.67494 58.0377 10.7327C61.0955 13.7905 63.5162 17.3863 65.2999 21.5199C67.0836 25.6536 67.9755 30.0704 67.9755 34.7703C67.9755 39.4703 67.0836 43.8871 65.2999 48.0208C63.5162 52.1544 61.0955 55.7502 58.0377 58.808C54.9799 61.8657 51.3842 64.2865 47.2505 66.0702C43.1168 67.8539 38.7 68.7458 34.0001 68.7458Z",
    fill: "#170026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e148dda57cace41d2b6f7bff4f70608d.svg";
export { ForwardRef as ReactComponent };